// extracted by mini-css-extract-plugin
export default {"select":"HW12_select__u+SV3"};